module.exports = __webpack_public_path__ + "fcee91a77f1677c1827aeb9c0dacf04a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-red-stripe.png
// module id = 2281
// module chunks = 0